<template>
  <div class="device-v-d-container">
    <iframe :src="deleteUrl" scrolling="auto" seamless height="100%" width="100%" frameborder="0" ref="iframe"> </iframe>
    <!-- <el-tabs class="tabs-style" v-model="activeName">
      <el-tab-pane label="虚拟设备录入" name="first" class="panes">
        <div class="wrapper"></div>
        <iframe :src="url" scrolling="auto" seamless height="100%" width="100%" frameborder="0" ref="iframe"> </iframe>
      </el-tab-pane>
      <el-tab-pane label="虚拟设备删除" name="second" class="panes">
        <iframe :src="deleteUrl" scrolling="auto" seamless height="100%" width="100%" frameborder="0" ref="iframe"> </iframe>
      </el-tab-pane>
    </el-tabs> -->
  </div>
</template>

<script>
export default {
  name: 'deviceVDelete',
  inject: ['reload'],
  data () {
    return {
      // url: 'https://scada.istarscloud.com/viewer/lUfZEypxnYtenq7K',
      // 删除虚拟数据 上面是正式 下面是测试
      // deleteUrl: 'https://scada.istarscloud.com/viewer/aDZL2MMYh8aXD4rv'
      deleteUrl: 'http://fes.natsuki.cc:8022/viewer/DyNWmhe7laANE1X1'
      // activeName: 'first'
    }
  },
  watch: {
    themeDark: function () {
      console.log('换主题1')
      this.pageReload()
    }
  },
  computed: {
    themeDark () {
      return this.$store.state.app.theme === '252C47'
    }
  },
  methods: {
    pageReload () {
      this.reload()
    }
  },
  mounted () {
    window.addEventListener('message', (e) => {
      console.log('aaa')
      const params = {
        tenantId: this.$store.state.user.tenantId,
        userId: this.$store.state.user.id,
        token: this.$store.getters.token,
        theme: this.$store.state.app.theme,
        project: this.$store.state.app.project
      }
      this.$refs.iframe.contentWindow.postMessage(JSON.stringify(params), '*')
    })
  }
}
</script>

<style lang="scss">
.device-v-d-container {
  height: 100%;
  width: 100%;
  .tabs-style {
    height: 100%;
    width: 100%;
    .el-tabs__content {
      height: 100%;
      .el-tab-pane {
        height: 100%;
      }
    }
  }
}
.el-tabs__content {
  height: 100%;
}
</style>
